module.exports = __webpack_public_path__ + "static/img/p_vip.e8e219e5.png";